import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from 'src/app/onboarding-process/utils/onboarding.util';
import { PolicyConsentService } from '../policy-consent.service';

@Injectable({
  providedIn: 'root',
})
export class PolicyConsentGuard {
  constructor(
    private router: Router,
    private policyConsentService: PolicyConsentService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const user = getLoginUserDetails();
    if (!user) {
      return of(this.router.createUrlTree(['/auth/login']));
    }
    if (!isOnboardingCompleteFromUser(user)) {
      return of(this.router.createUrlTree(['/onboarding', 'welcome']));
    }

    return this.policyConsentService.hasPendingConsent().pipe(
      map((hasPending) =>
        hasPending ? this.router.createUrlTree(['/policy-consent']) : true
      ),
      catchError(() => of(true))
    );
  }
}
